export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Accesso",
    "login.form.hint.user": "Login",
    "login.form.hint.password": "Password",
    "login.form.checkbox.remember-me": "Ricorda",
    "login.form.button.sign-in": "Accedi",
    "login.form.message.invalid-user-credentials": "Login o password errati",
    "login.form.message.account-temporarily-locked": "L'account è temporaneamente bloccato, riprovare tra 5 minuti",
    "login.form.message.user-required": "Inserire un login",
    "login.form.message.password-required": "Inserire una password",
    "login.form.button.forgot-password": "Password dimenticata?",
    "error.mfa-required.title": "Configura 2FA",
    "error.mfa-required.message1": "Per proteggere il tuo account, è richiesta l'autenticazione a due fattori (2FA).",
    "error.mfa-required.message2": "Verrai reindirizzato alle impostazioni del tuo account nella Dashboard online. Abilita 2FA, segui le istruzioni di configurazione, quindi torna qui.",
    "error.mfa-required.learnMore": "Per saperne di più su 2FA",
    "error.mfa-required.continue": "Continua",
    "error.root-admin-login.title": "Errore 403 – proibito",
    "error.root-admin-login.message": "Accesso eseguito come Amministratore di sola lettura. Per accedere alla console Web Recovery accedere come utente o amministratore del tenant cliente",
    "error.server-busy.message": "Il server è occupato, riprovare piu tardi.",
    "error.network-connection.title": "Errore della connessione di rete",
    "error.network-connection.message": "Controllare la connessione Internet e riprovare.",
    "error.internal-server-error.title": "Errore server interno",
    "error.internal-server-error.message": "Per risolvere l'errore, contattare il supporto fornendo i dettagli dell'errore:",
    "error.internal-server-error.copy.button": "Copia"
};
